import script from "./ResetForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetForm.vue?vue&type=script&setup=true&lang=js"

import "./ResetForm.vue?vue&type=style&index=0&id=03699093&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03699093"]])

export default __exports__